import styled from "@emotion/styled"
import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import { isLocale } from "@porsche-customer/slfinrtl-context-types"
import { PHeading, PText } from "@porsche-design-system/components-react"
import { spacingFluidMd, spacingFluidXl, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { ListingDescriptionView } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage, defineMessages, useIntl } from "react-intl"
import { getCustomerAppLanguageTags } from "src/common/getCustomerAppLanguageTags"
import { commonMessages } from "src/common/messages/common.messages"
import { Grid, GridItem } from "src/components"
import { useConfig } from "src/hooks"

const messages = defineMessages({
	listingDescriptionEmptyPlaceholder: {
		defaultMessage: "Please provide a description of the vehicle",
		id: "description.listingDescription.emptyPlaceholder",
	},
})

interface ListingDescriptionProps {
	view: ListingDescriptionView
}

export const ListingDescription = ({ view }: ListingDescriptionProps) => {
	const { formatDisplayName } = useIntl()
	const { marketplaceKey } = useDealerContext()
	const { carSalesLiteEnabled } = useConfig()
	return (
		<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
			<StyledGridItem size={{ base: 12, m: 6 }}>
				{carSalesLiteEnabled ? (
					<PText color="contrast-medium">
						<FormattedMessage {...commonMessages.notAvailableInCarsalesLite} />
					</PText>
				) : (
					getCustomerAppLanguageTags(marketplaceKey)
						.filter(isLocale)
						.map((locale, _i, list) => {
							const displayName = formatDisplayName(locale, {
								type: "language",
							})
							const text = view.descriptions[locale]
							return (
								<div key={locale}>
									{list.length > 1 && <PHeading size="sm">{displayName}</PHeading>}
									{text ? (
										<Description>{text}</Description>
									) : (
										<PText color="contrast-medium">
											<FormattedMessage {...messages.listingDescriptionEmptyPlaceholder} />
										</PText>
									)}
								</div>
							)
						})
				)}
			</StyledGridItem>
		</Grid>
	)
}

const StyledGridItem = styled(GridItem)`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
`

const Description = styled(PText)`
	white-space: break-spaces;
`
